import { Flex, Form, Image, Input, message, notification, Select, Space, Upload } from 'antd';
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import Constant from '../../lib/constant';
import SH_Model from '../../components/SH_Model';
import toSlug from '../../utils/convertStr';
import userApi from './../../api/user';
import Password from 'antd/es/input/Password';

const defaultData = {
	email: '',
	password: '',
	isAdmin: false,
};

function TV_user_detail(props, ref) {
	const { getUser } = props;
	const [formInstance, setFormInstance] = useState();
	const [open, setOpen] = useState(false);
	const [index, setIndex] = useState(defaultData);
	const [form] = Form.useForm();
	const refMode = useRef();
	const [initValue, setInitValue] = useState(defaultData);
	const [api, contextHolder] = notification.useNotification();

	const [images, setImages] = useState([]);
	const [loading, setLoading] = useState(false);
	const [errors, setErrors] = useState({});
	const propsErrors = {
		email: null,
		password: null,
	};
	const openNotificationWithIcon = (type, message, description) => {
		api[type]({
			message,
			description,
		});
	};
	useImperativeHandle(ref, () => ({
		create: () => {
			setImages([]);
			setOpen(true);
			refMode.current = Constant.crud.create;
		},
		update: (record) => {
			const { _id, ...remain } = record;
			setInitValue(remain);
			// setImages(res.data.document.images || []);
			console.log({ record });

			setIndex(record);
			setOpen(true);
			refMode.current = Constant.crud.update;
		},
	}));
	console.log(initValue);
	useEffect(() => {
		onFormInstanceReady(form);
	}, []);
	const onFormInstanceReady = (instance) => {
		setFormInstance(instance);
	};
	const validate = (props, data) => {
		const _data = structuredClone(data || initValue);
		const _errors = structuredClone(errors);

		if (!props) {
			props = propsErrors;
		}
		Object.keys(props).forEach((prop) => {
			switch (prop) {
				case 'email':
					if (_data[prop]?.length > 0) {
						const validateEmailRegex = /^\S+@\S+\.\S+$/;
						_errors[prop] = validateEmailRegex.test(_data[prop]) ? null : 'Email không hợp lệ';
					} else {
						_errors[prop] = _data[prop]?.length > 0 ? null : 'Dữ liệu không thể để trống';
					}
					break;
				default:
					_errors[prop] = _data[prop]?.length > 0 ? null : 'Dữ liệu không thể để trống';
					break;
			}
		});
		setErrors(_errors);
		return Object.values(_errors);
	};
	const handleSubmit = async () => {
		try {
			const _errorList = validate();
			console.log({ _errorList });

			if (_errorList.filter((x) => x).length === 0) {
				if (refMode.current === Constant.crud.create) {
					setLoading(true);
					userApi.create(initValue).then((res) => {
						openNotificationWithIcon('success', 'Thành công', 'Thao tác thành công');
						onCancel();
						getUser();
						setLoading(false);
					});
				}
			} else {
				{
					setLoading(true);
					console.log({ initValue });
					const { email, isAdmin } = initValue;
					userApi.update(initValue.id, { email, isAdmin }).then((res) => {
						openNotificationWithIcon('success', 'Thành công', 'Thao tác thành công');
						onCancel();
						getUser();
						setLoading(false);
					});
				}
			}
		} catch (err) {
			console.log(err);
		} finally {
			setLoading(false);
		}
	};

	console.log({ initValue });
	const onCancel = () => {
		setOpen(false);
		refMode.current = '';
		formInstance?.resetFields();
		setInitValue(defaultData);
		setIndex(defaultData);
		setErrors(propsErrors);
	};

	try {
		return (
			<>
				{contextHolder}
				<SH_Model
					width={300}
					open={open}
					handleSubmit={handleSubmit}
					onCancel={onCancel}
					textOk={refMode.current === Constant.crud.create ? 'Tạo mới' : 'Cập nhật'}
					loading={loading}
					title={refMode.current === Constant.crud.create ? 'Tạo mới người dùng' : 'Cập nhật người dùng'}
				>
					<label>Email</label>
					<Input
						disabled={refMode.current === Constant.crud.update}
						value={initValue.email}
						type="email"
						onChange={(e) => setInitValue((prev) => ({ ...prev, email: e.target.value }))}
					/>
					<p className="text-red-600">{errors['email']}</p>
					{refMode.current === Constant.crud.create && (
						<>
							<label>Mật khẩu</label>

							<Password
								value={initValue.password}
								onChange={(e) => setInitValue((prev) => ({ ...prev, password: e.target.value }))}
							/>
							<p className="text-red-600">{errors['password']}</p>
						</>
					)}

					<Flex className=" flex align-middle flex-col">
						<label>Vai trò</label>
						<Select
							defaultValue={''}
							style={{
								width: '100%',
							}}
							value={initValue.isAdmin}
							options={[
								{ value: true, label: 'Admin' },
								{ value: false, label: 'Người dùng' },
							]}
							onChange={(e) => setInitValue((prev) => ({ ...prev, isAdmin: e }))}
						/>
					</Flex>
				</SH_Model>
			</>
		);
	} catch (error) {
		console.log(error);
	}
}

export default forwardRef(TV_user_detail);
